import React from "react";
import "./ShowResult.css";

const ShowResult = ({
  score,
  totalQuestions,
  questions,
  selectedOptions,
  timeUsed,
  onReview,
  onRetry,
  onHome,
  sectionsMeta = [],
  sectionsOrder = []
}) => {
  const percent = totalQuestions === 0 ? 0 : Math.round((score / totalQuestions) * 100);

  const grade =
    percent >= 75 ? "A" :
    percent >= 65 ? "B" :
    percent >= 50 ? "C" :
    percent >= 35 ? "D" : "F";

  const minutes = Math.floor(timeUsed / 60);
  const seconds = timeUsed % 60;

  const getFeedback = () => {
    if (percent >= 80) return "🎉 Excellent! Outstanding performance!";
    if (percent >= 60) return "👍 Good job! You're improving.";
    if (percent >= 50) return "🙂 Fair score, keep practicing.";
    if (percent >= 35) return "Don't worry — you can do better with practice!.";
    return "Lets get you up on your fit, lets practice";
  };

  // Compute section scores
  const computeSectionScores = () => {
    if (!sectionsMeta || sectionsMeta.length === 0) {
      const tot = questions.length;
      let s = 0;
      questions.forEach((q, idx) => {
        if (selectedOptions[idx] !== undefined && selectedOptions[idx] === q.correctAnswer) s++;
      });
      return [{ name: null, score: s, total: tot }];
    }

    return sectionsMeta.map((meta, index) => {
      let s = 0;
      for (let i = 0; i < meta.length; i++) {
        const globalIdx = meta.startIndex + i;
        const q = questions[globalIdx];
        if (!q) continue;
        if (selectedOptions[globalIdx] !== undefined && selectedOptions[globalIdx] === q.correctAnswer) {
          s++;
        }
      }
      return { name: meta.name, score: s, total: meta.length };
    });
  };

  const sectionScores = computeSectionScores();
  const hasSections = sectionScores.length > 1 || (sectionScores.length === 1 && sectionScores[0].name !== null);

  return (
    <div className="result-wrapper">
      <div className="score-circle">
        <div className="percent-text">{percent}%</div>
        <div className="grade-text">Grade {grade}</div>
      </div>

      <div className="summary-box">
        <h2 className="summary-title">Your Performance</h2>

        <div className="summary-row">
          <span className="summary-label">Total Questions:</span>
          <span className="summary-value">{totalQuestions}</span>
        </div>

        <div className="summary-row">
          <span className="summary-label">Correct Answers:</span>
          <span className="summary-value correct">{score}</span>
        </div>

        <div className="summary-row">
          <span className="summary-label">Incorrect Answers:</span>
          <span className="summary-value incorrect">{totalQuestions - score}</span>
        </div>

        <div className="summary-row">
          <span className="summary-label">Time Used:</span>
          <span className="summary-value">
            {minutes}m {seconds}s
          </span>
        </div>

        {hasSections && (
          <div className="section-scores">
            <h3 className="section-scores-title">Section Breakdown:</h3>
            {sectionScores.map((sec, idx) => (
              <div key={idx} className="section-score-row">
                <span className="section-label">
                  {sec.name ? `${sec.name}` : `Section ${idx + 1}`}:
                </span>
                <span className="section-value">
                  {sec.score}/{sec.total} ({sec.total === 0 ? 0 : Math.round((sec.score / sec.total) * 100)}%)
                </span>
              </div>
            ))}
          </div>
        )}

        <div className="feedback">{getFeedback()}</div>
      </div>

      <div className="result-buttons">
        <button
          className={`review-btn ${score === totalQuestions ? 'disabled' : ''}`}
          onClick={onReview}
          disabled={score === totalQuestions}
        >
          {score === totalQuestions ? 'No Mistakes to Review' : 'Review Mistakes'}
        </button>

        <button className="retry-btn" onClick={onRetry}>
          Retake Exam
        </button>
      </div>
    </div>
  );
};

export default ShowResult;